import React from 'react';
import { styles } from './styles';
import SectionWrapper from '../../components/sectionWrapper/sectionWrapper';
import kaanSozer from '../../assets/images/kaanSozer.png';

const About: React.FC = () => {
  return (
    <SectionWrapper id="about" label="About" heading="Engineering that delivers">
      <div className="about-grid" style={styles.grid}>
        {/* Founder card */}
        <div style={styles.founderCard}>
          <div style={styles.avatar}>
            <img src={kaanSozer} alt="Kaan Sozer" style={styles.avatarImg} />
          </div>
          <div style={styles.founderMeta}>
            <p style={styles.founderName}>Kaan Sozer</p>
            <p style={styles.founderTitle}>Founder &amp; CEO, Novaeon LLC</p>
          </div>
        </div>

        {/* About text */}
        <div style={styles.textTile}>
          <p style={styles.bodyText}>
            Novaeon, an Arizona-based technology company that designs, builds, and ships software
            for the businesses we partner with, from intelligent AI systems to full-scale
            digital products and original games.
          </p>
          <p style={styles.bodyText}>
            Founded by <strong style={styles.bodyStrong}>Kaan Sozer</strong>, who brings a
            decade of experience across web, mobile, and game development, including enterprise
            systems for large organizations (backend APIs, microservices, and the platforms and
            internal tools they run on) and consumer applications shipped to the App Store.
          </p>

          <p style={styles.bodyText}>
            We hold every engagement to one standard: software engineered with rigor, delivered
            with care, and easy to work with from the first call through launch and beyond.
            Alongside client work, we build our own products across software, AI, and games, the
            first steps toward a larger goal: technology that makes life meaningfully better.
          </p>
          <p style={styles.footnote}>
            Novaeon LLC &nbsp;/&nbsp; Registered in Arizona &nbsp;/&nbsp; EIN on file &nbsp;/&nbsp; novaeon.io
          </p>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default About;
